<div class="flex relative mb-4 items-center gap-2">
  <proffeo-ui-input
    [(value)]="search"
    variant="search"
    placeholder="placeholders.search-input"
    class="grow-3"
  />

  @if (selectMode() === SelectMode.MULTIPLE) {
    <div class="flex items-center shrink-0 whitespace-nowrap">
      <mat-checkbox
        (change)="toggleAllIndustries($event)"
        [checked]="isAllIndustriesSelected()"
      >
        {{ 'ui-forms-select-all' | translate }}
      </mat-checkbox>
    </div>
  }
</div>

<div class="h-full flex-grow">
  @for (industry of filteredIndustries(); track industry?.id; let isLast = $last) {
    <div class="flex items-center">
      <div
        [ngClass]="isLast ? '' : 'border-b border-proffeo-surface-off'"
        class="flex-column flex w-full items-center py-2"
      >
        @if (selectMode() === SelectMode.SINGLE) {
          <mat-radio-button
            (change)="selectIndustry(true, industry)"
            [value]="industry.id"
            [checked]="selectedIndustries()[0]?.id === industry.id"
            class="mr-2 shrink-0"
          />
        } @else {
          <div class="flex items-center justify-center shrink-0 self-center mr-2">
            <mat-checkbox
              (change)="onIndustryCheckboxChange($event, industry)"
              [checked]="isSelected(industry.id)"
            ></mat-checkbox>
          </div>
        }

        <div class="ml-2 flex w-full flex-col truncate py-2">
          <p>{{ industry?.name }}</p>
        </div>
      </div>
    </div>
  }
</div>
